import hrInterview1 from "../../../assets/images/career/hrInterview1.svg";
import hrInterview2 from "../../../assets/images/career/hrInterview2.svg";
import hrInterview3 from "../../../assets/images/career/hrInterview3.svg";

export default [
  {
    icon: hrInterview1,
    name: "HR Interview",
    description:
      "HR interview at Veritekno, we focus on aligning your career goals with our organizational values. This conversation delves into your professional journey, aspirations, and how you envision contributing to our vibrant workplace culture.",
  },
  {
    icon: hrInterview2,
    name: "Personal Interview",
    description:
      "Personal Interview at Veritekno, we aim to understand you beyond your resume. Engage in thoughtful discussions with our team, sharing your experiences, aspirations, and problem-solving approaches.",
  },
  {
    icon: hrInterview3,
    name: "Practical Round",
    description:
      "In the Practical Round at Veritekno, demonstrate your technical prowess in real-world scenarios. This hands-on session allows you to showcase your problem-solving abilities and technical skills. Engage with practical challenges relevant to the role",
  },
];
